export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_20.0bd85568.jpg";